import useSWR from 'swr';

import type { UserProfile } from '@steadioTypes/user';
import type { SteadioApiError } from '@steadioTypes/common';

export default function useUserProfile() {
  const {
    data: userProfile,
    mutate,
    error,
  } = useSWR<UserProfile, SteadioApiError>('/api/v1/creator/edit', null, {
    revalidateIfStale: false,
    shouldRetryOnError: false,
  });

  return {
    userProfile: userProfile as UserProfile,
    mutate,
    error,
    loading: !userProfile && !error,
    isSignedOut: error?.status === 401,
  };
}
